import { Injectable } from '@angular/core';
import { forkJoin } from 'rxjs';
import { signal, WritableSignal } from '@angular/core';
import { HiringRequestService } from '@pages/hiring-manager/hiring-request/hiring-request.service';
import { VendorService } from './vendor.service';

type DataServiceKeys =
  | 'lobs'
  | 'employees'
  | 'projects'
  | 'skills'
  | 'vendors'
  | 'userProfile';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  lobs: WritableSignal<any> = signal(null);
  employees: WritableSignal<any> = signal(null);
  projects: WritableSignal<any> = signal(null);
  skills: WritableSignal<any> = signal(null);
  vendors: WritableSignal<any> = signal(null);
  userProfile: WritableSignal<any> = signal(null);


  private readonly storageKey = 'masterData';

  constructor(
    private hiringRequestService: HiringRequestService,
    private vendorService: VendorService,
  ) {
    this.loadFromLocalStorage();
    this.loadUserProfiles();
  }

  loadData() {
    forkJoin({
      lobs: this.hiringRequestService.getLobData(),
      employees: this.hiringRequestService.getEmployeeData(),
      projects: this.hiringRequestService.getProjectData(),
      skills: this.hiringRequestService.getSkillData(),
    }).subscribe(
      (data) => {
        Object.entries(data).forEach(([key, value]) =>
          (this[key as DataServiceKeys] as WritableSignal<any>).set(value),
        );
        this.updateLocalStorage();
        this.vendorService.vendorDetails$.subscribe((vendorDetails) => {
          this.vendors.set(vendorDetails);
          this.updateLocalStorage();
        });
      },
      (error) => console.error('Error loading data', error),
    );
  }

  private loadFromLocalStorage() {
    const data = localStorage.getItem(this.storageKey);
    if (data) {
      const parsedData = JSON.parse(data);
      Object.entries(parsedData).forEach(([key, value]) => {
        const signal = this[key as DataServiceKeys] as WritableSignal<any>;
        if (signal?.set instanceof Function) {
          signal.set(value);
        }
      });
    }
  }

  private updateLocalStorage() {
    const data = {
      lobs: this.lobs(),
      employees: this.employees(),
      projects: this.projects(),
      skills: this.skills(),
      vendors: this.vendors(),
    };
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  private loadUserProfiles() {
    const userProfile=sessionStorage.getItem('userProfile');
    if(userProfile){
      this.userProfile.set(JSON.parse(userProfile));
    }
  }
}
